import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import LanguageSelector from "./LanguageSelector";

const FloatingLanguageSelector: React.FC = () => {
  const [isDark, setIsDark] = useState(
    () => localStorage.getItem("theme") === "dark",
  );

  useEffect(() => {
    const handler = (e: Event) => setIsDark((e as CustomEvent).detail.isDark);
    window.addEventListener("appThemeChange", handler);
    return () => window.removeEventListener("appThemeChange", handler);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 10000,
        background: "transparent",
      }}
    >
      <LanguageSelector isDarkTheme={isDark} />
    </Box>
  );
};

export default FloatingLanguageSelector;
